// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-NA2":"NA2_dpu-detail-NA2__aMDxT"};